{
  "search": {
    "heading": "Sök patient",
    "label": "Namn, personnummer eller reservnummer",
    "hint": "Minst {minimum} tecken. Personnummer kan skrivas med eller utan bindestreck och med eller utan sekelsiffror.",
    "searching": "Söker …",
    "empty": "Ingen patient i journalen matchar sökningen.",
    "failed": "Sökningen kunde inte genomföras.",
    "retry": "Försök igen",
    "tooLong": "Söktexten är för lång. Högst {maximum} tecken.",
    "caption": "Sökträffar, en rad per patient.",
    "count": "{count, plural, =0 {Ingen träff} one {# träff} other {# träffar}}",
    "truncated": "Visar de {limit} första träffarna. Precisera sökningen."
  },
  "column": {
    "name": "Namn",
    "identifier": "Personnummer / reservnr",
    "age": "Ålder",
    "location": "Vårdplats",
    "safety": "Varningar"
  },
  "location": {
    "notAdmitted": "Inte inskriven",
    "wardAndBed": "{ward} plats {bed}",
    "wardOnly": "{ward}, utan plats"
  },
  "overview": {
    "back": "Tillbaka",
    "loading": "Hämtar patientöversikten …",
    "failed": "Patientöversikten kunde inte hämtas.",
    "notFound": "Patienten finns inte i journalen.",
    "retry": "Försök igen",
    "birthDate": "Född",
    "age": "Ålder",
    "sex": "Kön",
    "ward": "Avdelning",
    "location": "Vårdplats",
    "admitted": "Inskriven",
    "responsible": "Ansvarig läkare",
    "safetyHeading": "Säkerhetsinformation",
    "medicationsHeading": "Aktuella läkemedel",
    "notesHeading": "Senaste anteckningarna",
    "noMedications": "Inga aktuella läkemedelsordinationer i journalen.",
    "noNotes": "Inga signerade anteckningar i journalen.",
    "moreNotes": "Visar de {count} senaste anteckningarna. Äldre anteckningar finns i journalen.",
    "readOnly": "Nya ordinationer och administrering ingår inte i fas 0. Doseringen i en befintlig ordination kan ändras, allergier och varningar dokumenteras, och anteckningar skrivas och signeras."
  },
  "practitioner": {
    "notDocumented": "Ej dokumenterad"
  },
  "identifier": {
    "personnummer": "Personnummer",
    "samordningsnummer": "Samordningsnummer",
    "reservnummer": "Reservnummer",
    "unknownSeries": "Okänd nummerserie",
    "withAssigner": "{value} (utfärdat av {assigner})",
    "none": "Ingen identitetsbeteckning i journalen"
  },
  "sex": {
    "male": "Man",
    "female": "Kvinna",
    "other": "Annat",
    "unknown": "Okänt"
  },
  "safety": {
    "allergies": "Allergier",
    "dnr": "DNR",
    "treatmentLimitation": "Behandlingsbegränsning",
    "isolation": "Isolering",
    "weight": "Vikt",
    "infectionRisk": "Smittrisk",
    "fallRisk": "Fallrisk",
    "allergyStatusUnknown": "Allergistatus ej utredd",
    "other": "Övrigt",
    "otherFlag": "{label}: {value}",
    "dnrNotDocumented": "Inget dokumenterat",
    "treatmentLimitationNotDocumented": "Ingen dokumenterad",
    "isolationNotDocumented": "Ingen dokumenterad",
    "weightNotDocumented": "Ingen vikt dokumenterad",
    "weightKg": "{weight} kg",
    "valueNotRecorded": "Dokumenterat utan närmare uppgift",
    "isolationTypeNotRecorded": "typ ej angiven",
    "decidedBy": "Beslut: {name}, {time}",
    "decidedByWithTitle": "Beslut: {title} {name}, {time}"
  },
  "allergy": {
    "line": "{substance} ({qualifiers})",
    "lineWithReaction": "{substance} ({qualifiers}) — {reaction}",
    "substanceNotRecorded": "Substans ej angiven",
    "severityMild": "lindrig",
    "severityModerate": "måttlig",
    "severitySevere": "svår",
    "severityNotRecorded": "svårighetsgrad ej angiven",
    "criticalityHigh": "hög risk vid ny exponering",
    "criticalityLow": "låg risk vid ny exponering",
    "criticalityUnableToAssess": "risk går inte att bedöma",
    "unconfirmed": "ej bekräftad",
    "resolved": "utläkt"
  },
  "medication": {
    "caption": "Aktuella läkemedelsordinationer, en rad per ordination.",
    "columnSubstance": "Läkemedel",
    "columnPreparation": "Beredning",
    "columnDose": "Dos",
    "columnRoute": "Adm.väg",
    "columnSchedule": "Dosering",
    "columnIndication": "Indikation",
    "columnOrdered": "Ordinerat",
    "preparation": "{strength} {form}",
    "prn": "Vid behov, {frequency}. Högst {maximum} per dygn.",
    "prnWithoutMaximum": "Vid behov, {frequency}. Ingen maxdos per dygn dokumenterad.",
    "orderedBy": "Ordinerat av {name}",
    "endsAt": "Till och med {time}",
    "columnCorrect": "Ändra"
  },
  "notes": {
    "typeDaily": "Daganteckning",
    "typeAdmission": "Inskrivningsanteckning",
    "typeDischarge": "Utskrivningsanteckning",
    "attribution": "{name}, {time}",
    "attributionWithTitle": "{title} {name}, {time}",
    "recordedLater": "Dokumenterat i journalen {time}",
    "amended": "Rättad, version {version}",
    "otherLanguage": "Skriven på {language}",
    "subjective": "Subjektivt",
    "objective": "Objektivt",
    "assessment": "Bedömning",
    "plan": "Plan"
  },
  "history": {
    "heading": "Versioner av patientuppgifterna",
    "show": "Visa alla versioner av uppgifterna",
    "hide": "Dölj versionerna av uppgifterna",
    "loading": "Läser versioner …",
    "failed": "Versionerna kunde inte läsas.",
    "notFound": "Patienten finns inte i journalen.",
    "retry": "Försök igen",
    "count": "{count, plural, one {# version} other {# versioner}}",
    "number": "Version {version}",
    "current": "Nuvarande version",
    "superseded": "Ersatt av en senare version",
    "retracted": "Markerad som felaktigt införd",
    "author": "{name}",
    "authorWithTitle": "{title} {name}",
    "written": "Skriven i journalen {time}",
    "effective": "Uppgifterna gäller från {time}",
    "changed": "Ändrad i den här versionen",
    "fieldStatus": "Status",
    "fieldIdentity": "Identitet",
    "identityAssumed": "Antagen, inte styrkt",
    "identityEstablished": "Styrkt",
    "statusActive": "Aktuell",
    "statusInactive": "Inte aktuell",
    "statusRetracted": "Felaktigt införd",
    "yes": "Ja",
    "no": "Nej"
  },
  "export": {
    "action": "Exportera (FHIR)",
    "working": "Exporterar …",
    "refused": "Din roll får inte exportera journalen.",
    "notFound": "Patienten finns inte i journalen.",
    "unavailable": "Exporten kunde inte hämtas. Försök igen.",
    "notEncrypted": "Filen är okrypterad. Den här versionen innehåller bara påhittade uppgifter."
  }
}
